import Axios from "axios"

const state = {
  lanType : 0,
  cn_config: null,
  en_config: null
}
//  0未知  \ 1 中文 \2 英文

 export function isChinese() {
  loadCachedLanStatus()
  if (state.lanType == 2){ //英文
    return false
  }else {
    return true
  }
 }

 export function getCurLan() {
   if(state.lanType == 0){
     loadCachedLanStatus()
   }
    if (state.lanType == 1){ //中文
      if (state.cn_config == null) {
        return Axios.get('static/json/chconfig.json')
        .then(res => {
          state.cn_config = res.data
          return state.cn_config
        })
      } else {
        return new Promise((resolve, reject) => {
          resolve(state.cn_config)
        })
      }
    }else {
      if(state.en_config == null) {
        return Axios.get('static/json/enconfig.json')
        .then(res => {
          state.en_config = res.data
          return state.en_config
        })
      } else {
        return new Promise((resolve, reject) => {
          resolve(state.en_config)
        })
      }
    }
  }
  
  export  function changeLan() {
    if (state.lanType == 1){ //中文
      state.lanType = 2
      localStorage.setItem("isChinese", "false");
    }else {
      state.lanType = 1
      localStorage.setItem("isChinese", "true");
    }
  }
  
  export function loadCachedLanStatus() {
    if(state.lanType > 0){
      return
    }
    if (localStorage.getItem("isChinese") && localStorage.getItem("isChinese") == "false") {
      state.lanType = 2
    } else {
      state.lanType = 1
    }
  }

  export default {
    state
  }
  
  


// WEBPACK FOOTER //
// ./src/util/tools.js